module.exports = __webpack_public_path__ + "static/tnoce-logo.51110435.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tnoce-logo.png
// module id = 601
// module chunks = 114276838955818